/* Grace Parker — Hero / Buy Box (Variant A) · Behavior */
(function () {
  'use strict';

  document.querySelectorAll('[data-gp-hero]').forEach(initHero);

  function initHero(root) {
    const variantsScript = root.querySelector('[data-variants-json]');
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }

    const variantInput = root.querySelector('[data-variant-id-input]');
    const optionInputs = root.querySelectorAll('[data-option-input]');
    const priceEl      = root.querySelector('[data-price]');
    const addPriceEl   = root.querySelector('[data-add-price]');
    const stickyPriceEl= root.querySelector('[data-sticky-price]');
    const addBtn       = root.querySelector('[data-add-button]');
    const addText      = root.querySelector('[data-add-text]');
    const stickyAddBtn = root.querySelector('[data-sticky-add]');
    const stickyBar    = root.querySelector('[data-sticky-bar]');
    const scarcity     = root.querySelector('[data-scarcity]');
    const stockCount   = root.querySelector('[data-stock-count]');
    const giftWrap     = root.querySelector('[data-gift-wrap]');
    const form         = root.querySelector('[data-product-form]');
    const thumbs       = root.querySelectorAll('[data-thumb-index]');
    const medias       = root.querySelectorAll('[data-media-index]');
    const counterEl    = root.querySelector('[data-current-index]');
    const navPrev      = root.querySelector('[data-nav-prev]');
    const navNext      = root.querySelector('[data-nav-next]');
    const mediaWrap    = root.querySelector('[data-media-wrap]');
    const dots         = root.querySelectorAll('[data-dot-index]');
    const totalMedia   = medias.length;

    /* ───── Gallery ───── */
    let activeIndex = 0;

    function goTo(i) {
      if (totalMedia === 0) return;
      activeIndex = ((i % totalMedia) + totalMedia) % totalMedia;
      thumbs.forEach((b) => {
        const isActive = parseInt(b.dataset.thumbIndex, 10) === activeIndex;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      medias.forEach((m) => {
        m.classList.toggle('is-active', parseInt(m.dataset.mediaIndex, 10) === activeIndex);
      });
      dots.forEach((d) => {
        d.classList.toggle('is-active', parseInt(d.dataset.dotIndex, 10) === activeIndex);
      });
      if (counterEl) counterEl.textContent = String(activeIndex + 1);
    }

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => goTo(parseInt(btn.dataset.thumbIndex, 10)));
    });
    if (navPrev) navPrev.addEventListener('click', () => goTo(activeIndex - 1));
    if (navNext) navNext.addEventListener('click', () => goTo(activeIndex + 1));

    /* Keyboard nav (when gallery is focused) */
    if (mediaWrap) {
      mediaWrap.tabIndex = 0;
      mediaWrap.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(activeIndex - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(activeIndex + 1); }
      });
    }

    /* Touch swipe (mobile) */
    if (mediaWrap) {
      let startX = 0, startY = 0, tracking = false;
      mediaWrap.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      mediaWrap.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        const t = e.changedTouches[0];
        const dx = t.clientX - startX;
        const dy = t.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          goTo(activeIndex + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    /* ───── Variant matching ───── */
    function getSelectedOptions() {
      const result = [];
      root.querySelectorAll('[data-option-input]:checked').forEach((inp) => {
        const pos = parseInt(inp.dataset.optionPosition, 10) - 1;
        result[pos] = inp.value;
      });
      return result;
    }

    function findVariant(opts) {
      return variants.find((v) => {
        return opts.every((val, i) => v.options[i] === val);
      });
    }

    function formatMoney(cents) {
      // Falls back to a basic USD formatter if Shopify's helper isn't on the page.
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        const fmt = (window.theme && theme.moneyFormat) || '${{amount}}';
        return Shopify.formatMoney(cents, fmt);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updateVariant() {
      const opts = getSelectedOptions();
      const variant = findVariant(opts);

      // Update each fieldset's selected-value display
      root.querySelectorAll('.gp-hero__option').forEach((fs) => {
        const checked = fs.querySelector('[data-option-input]:checked');
        const display = fs.querySelector('[data-selected-value]');
        if (checked && display) display.textContent = checked.value;
      });

      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          if (addText) addText.textContent = 'Unavailable';
          if (addPriceEl) addPriceEl.textContent = '';
        }
        return;
      }

      variantInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? (root.dataset.ctaLabel || 'Add to bag') : 'Sold out';

      const money = formatMoney(variant.price);
      if (priceEl) priceEl.textContent = money;
      if (stickyPriceEl) stickyPriceEl.textContent = money;

      // Switch gallery to this variant's featured media (if any)
      const mediaId = variant.featured_media && variant.featured_media.id;
      if (mediaId) {
        const target = root.querySelector('[data-media-id="' + mediaId + '"][data-media-index]');
        if (target) {
          const idx = parseInt(target.dataset.mediaIndex, 10);
          if (!Number.isNaN(idx)) goTo(idx);
        }
      }

      // Scarcity — handled by the live ticker below; just keep it visible
      if (scarcity) scarcity.hidden = false;

      // Update URL with variant
      if (history && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach((inp) => {
      inp.addEventListener('change', () => {
        // Immediate gallery swap from the clicked swatch (works even before all options form a valid variant)
        const mid = inp.dataset.variantMediaId;
        if (mid) {
          const target = root.querySelector('[data-media-id="' + mid + '"][data-media-index]');
          if (target) {
            const idx = parseInt(target.dataset.mediaIndex, 10);
            if (!Number.isNaN(idx)) goTo(idx);
          }
        }
        updateVariant();
      });
    });

    /* ───── Gift wrap upsell ───── */
    if (giftWrap && form) {
      form.addEventListener('submit', async (e) => {
        if (!giftWrap.checked) return; // let it submit normally
        e.preventDefault();
        try {
          // 1) Add main product
          const mainRes = await fetch(window.Shopify ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
            body: new URLSearchParams(new FormData(form)).toString()
          });
          if (!mainRes.ok) throw new Error('main add failed');

          // 2) Add gift wrap
          const giftId = giftWrap.dataset.giftVariantId;
          await fetch(window.Shopify ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: giftId, quantity: 1 }] })
          });

          // 3) Go to cart (or open drawer if your theme uses one)
          window.location.href = (window.Shopify ? Shopify.routes.root : '/') + 'cart';
        } catch (err) {
          // Fallback: submit the form normally
          form.submit();
        }
      });
    }

    /* ───── Mobile peek scroller — sync dots/state to scroll position ───── */
    if (mediaWrap) {
      const isMobileLayout = () => window.matchMedia('(max-width: 749px)').matches;

      let scrollRaf = 0;
      mediaWrap.addEventListener('scroll', () => {
        if (!isMobileLayout()) return;
        cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(() => {
          const slideWidth = mediaWrap.clientWidth;
          if (!slideWidth) return;
          const i = Math.round(mediaWrap.scrollLeft / slideWidth);
          if (i !== activeIndex) {
            activeIndex = Math.max(0, Math.min(totalMedia - 1, i));
            dots.forEach((d) => {
              d.classList.toggle('is-active', parseInt(d.dataset.dotIndex, 10) === activeIndex);
            });
          }
        });
      }, { passive: true });

      // Dots tap → scroll to that media on mobile
      dots.forEach((d) => {
        d.addEventListener('click', () => {
          const i = parseInt(d.dataset.dotIndex, 10);
          if (isMobileLayout()) {
            const slideWidth = mediaWrap.clientWidth;
            mediaWrap.scrollTo({ left: i * slideWidth, behavior: 'smooth' });
          } else {
            goTo(i);
          }
        });
      });
    }

    /* ───── Live scarcity ticker — per-visitor, decreases every 30s ─────
       - Always visible (never hides).
       - First load: pick a starting count between START_MIN..START_MAX.
       - Every TICK_MS the count decreases by 1–2.
       - Floors at FLOOR; once it hits the floor it stays there.
       - Persisted in localStorage per product so refreshes don't reset. */
    if (scarcity && stockCount) {
      const productKey = root.dataset.productId || 'gp-product';
      const STORAGE_KEY = 'gp_scarcity_' + productKey;
      const TICK_MS    = parseInt(root.dataset.scarcityTickMs || '30000', 10);
      const START_MIN  = parseInt(root.dataset.scarcityStartMin || '4', 10);
      const START_MAX  = parseInt(root.dataset.scarcityStartMax || '6', 10);
      const FLOOR      = parseInt(root.dataset.scarcityFloor || '2', 10);

      function readState() {
        try {
          const raw = localStorage.getItem(STORAGE_KEY);
          if (raw) return JSON.parse(raw);
        } catch (e) {}
        return null;
      }
      function writeState(s) {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch (e) {}
      }

      let state = readState();
      const now = Date.now();

      if (!state || typeof state.count !== 'number') {
        const start = Math.min(6, START_MIN + Math.floor(Math.random() * Math.max(1, START_MAX - START_MIN + 1)));
        state = { count: start, lastTick: now };
        writeState(state);
      } else {
        // Cap any pre-existing high values from older visits
        if (state.count > 6) state.count = 6;
        // Catch up on missed ticks while the page was closed
        const elapsed = Math.max(0, now - (state.lastTick || now));
        const missed = Math.floor(elapsed / TICK_MS);
        if (missed > 0) {
          for (let i = 0; i < missed; i++) {
            state.count = Math.max(FLOOR, state.count - 1);
          }
          state.lastTick = now;
          writeState(state);
        }
      }

      stockCount.textContent = state.count;
      scarcity.hidden = false;

      setInterval(() => {
        if (state.count <= FLOOR) return;
        state.count = Math.max(FLOOR, state.count - 1);
        state.lastTick = Date.now();
        writeState(state);
        // Subtle pulse on update
        stockCount.textContent = state.count;
        scarcity.classList.remove('is-pulse');
        // force reflow to restart animation
        void scarcity.offsetWidth;
        scarcity.classList.add('is-pulse');
      }, TICK_MS);
    }

    /* ───── Rolling "Ships by" date — always tomorrow ───── */
    const shipsByEl = root.querySelector('[data-ships-by]');
    if (shipsByEl) {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      shipsByEl.textContent = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }

    /* Initial variant sync */
    updateVariant();

    /* ── Review slider ── */
    initReviewSlider(root);

    /* ── Size guide modal ── */
    initSizeGuide(root);
  }

  function initSizeGuide(root) {
    const modal = root.querySelector('[data-size-guide-modal]');
    if (!modal) return;
    const opens = root.querySelectorAll('[data-size-guide-open]');
    const closes = modal.querySelectorAll('[data-size-guide-close]');
    let lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      const closeBtn = modal.querySelector('.gp-hero__sg-close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    opens.forEach((b) => b.addEventListener('click', open));
    closes.forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initReviewSlider(root) {
    const slider = root.querySelector('[data-reviews-slider]');
    if (!slider) return;
    const track = slider.querySelector('[data-rs-track]');
    const cards = track ? Array.from(track.children) : [];
    if (!track || cards.length === 0) return;

    const prev = slider.querySelector('[data-rs-prev]');
    const next = slider.querySelector('[data-rs-next]');
    const dotsHost = slider.querySelector('[data-rs-dots]');

    function step() {
      const first = cards[0];
      const second = cards[1];
      if (second) return second.getBoundingClientRect().left - first.getBoundingClientRect().left;
      return first.getBoundingClientRect().width;
    }
    function activeIndex() {
      const s = step();
      if (s <= 0) return 0;
      return Math.round(track.scrollLeft / s);
    }
    function goTo(i) {
      const max = cards.length - 1;
      const idx = Math.max(0, Math.min(max, i));
      track.scrollTo({ left: idx * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', () => goTo(activeIndex() - 1));
    if (next) next.addEventListener('click', () => goTo(activeIndex() + 1));

    /* Build dots */
    if (dotsHost) {
      dotsHost.innerHTML = '';
      cards.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to review ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', () => goTo(i));
        dotsHost.appendChild(b);
      });
    }
    function syncDots() {
      if (!dotsHost) return;
      const idx = activeIndex();
      Array.from(dotsHost.children).forEach((d, i) => {
        if (i === idx) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= cards.length - 1;
    }
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(syncDots);
    });
    window.addEventListener('resize', syncDots);
    syncDots();
  }
})();
